"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._MetadataEntry = {
    type: "structure",
    required: [],
    members: {
        Name: {
            shape: {
                type: "string"
            }
        },
        Value: {
            shape: {
                type: "string"
            }
        }
    }
};
//# sourceMappingURL=_MetadataEntry.js.map